import React from 'react';
import { Link } from 'react-router-dom';

const CategoryBlock = ({ Background, label, url, appear, delay }) => {
  return (
    <div className='col-md-4 overflow-hide'>
      <div
        style={{ transitionDelay: `${delay}s` }}
        className={appear ? 'overlay-hide' : 'overlay-layer'}
      ></div>
      <Link to={`/products/${url}`}>
        <div
          className='category-block'
          style={{ backgroundImage: 'url(' + Background + ')' }}
        >
          <div className='overflow-hide'>
            <h2
              style={{ transitionDelay: `${delay + 0.1}s` }}
              className={appear ? 'h2-appear' : 'hide-btn'}
            >
              {label}
            </h2>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CategoryBlock;
